import { EXPRESSIVE_TAGS } from "@ai-guidance/shared";

/**
 * Tagurile expresive ([warmly], [confidently]) sunt DIRECȚII DE INTERPRETARE
 * pentru sinteza ElevenLabs, nu conținut - vezi `buildVoiceSegment` în backend,
 * unde vocabularul e închis exact la acestea două. Providerul le consumă din
 * text; transcriptul pe care ni-l dă înapoi le păstrează, iar vizitatorul le-a
 * văzut scrise în panou și sub orb (raportat 9 aug 2026).
 *
 * Curățarea se face DOAR la randare, aici, în browser:
 * - pe server textul rămâne intact - altfel tagul n-ar mai ajunge la sinteză și
 *   s-ar pierde exact expresivitatea pentru care există;
 * - ce se salvează local (istoricul conversației) rămâne tot brut, iar
 *   filtrarea se aplică la re-randare, prin aceleași două puncte.
 *
 * Set ÎNCHIS și potrivire doar la ÎNCEPUT de string, deliberat: o curățare
 * generică de paranteze drepte ar mutila numele de produse („Bosch [GKS 190]").
 * Lista de taguri e canonică în @ai-guidance/shared (`expressiveTags.ts`) -
 * dashboard-ul o refolosește pentru curățarea completă (toate aparițiile) la
 * randarea transcriptelor stocate.
 */

/**
 * Scoate UN singur tag expresiv de la începutul textului. Orice altceva -
 * un tag la mijloc, un tag inventat, paranteze din numele produsului - trece
 * neatins: aici curățăm ce știm sigur că e o direcție de interpretare.
 */
export function stripExpressiveTag(text: string): string {
  const leading = text.length - text.trimStart().length;
  const rest = text.slice(leading);
  const lower = rest.toLowerCase();
  for (const tag of EXPRESSIVE_TAGS) {
    if (lower.startsWith(tag)) return rest.slice(tag.length).trimStart();
  }
  return text;
}
